// extracted by mini-css-extract-plugin
export default {"conChannel":"index_conChannel_WIjzH"};